var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 13C42.159 13 13 42.159 13 78C13 113.841 42.159 143 78 143C113.841 143 143 113.841 143 78C143 42.159 113.841 13 78 13ZM78 130C49.3285 130 26 106.672 26 78C26 49.3285 49.3285 26 78 26C106.672 26 130 49.3285 130 78C130 106.672 106.672 130 78 130Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25 78C60.6348 78 65 73.6348 65 68.25C65 62.8652 60.6348 58.5 55.25 58.5C49.8652 58.5 45.5 62.8652 45.5 68.25C45.5 73.6348 49.8652 78 55.25 78Z",
    fill: "#0066FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.705 77.909C106.064 77.909 110.409 73.5642 110.409 68.2045C110.409 62.8449 106.064 58.5 100.705 58.5C95.3449 58.5 91 62.8449 91 68.2045C91 73.5642 95.3449 77.909 100.705 77.909Z",
    fill: "#0066FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 117C104 117 110.5 91 110.5 91H45.5C45.5 91 52 117 78 117Z",
    fill: "#0066FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsIcon);
export default __webpack_public_path__ + "static/media/kids_icon.1a9fff4e.svg";
export { ForwardRef as ReactComponent };